<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <!-- <v-card-title>
     Spare Part/Material Master List
    </v-card-title> -->
            <v-card-title>
              <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="addData"
                v-if="role.create"
              >
                Add Part/Material
              </v-btn>
              <!-- <drop-down>
                <v-btn
                  color="primary"
                  dark
                  slot="title"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                >
                  REQ / TF PART
                </v-btn>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li>
                    <a style="margin-left:-20px;" @click="addReqSP"
                      >Request Spare Part</a
                    >
                  </li>
                  <li>
                    <a style="margin-left:-20px;" @click="addTfSP"
                      >Transfer Spare Part</a
                    >
                  </li>
                </ul>
              </drop-down> -->
              <!-- <v-btn color="primary" dark class="ma-2" @click="addReqSP">
                Request Part
              </v-btn>
              <v-btn color="primary" dark class="ma-2" @click="addReqSP">
                Transfer Part
              </v-btn> -->
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link>
                    <downloadExcel
                      :data="dataExport(table)"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item link>
                    <downloadExcel
                      :data="exportAllFitered"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="!option_warehouse"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-card-title v-if="option_warehouse" style="padding-top: 0px;">
              
              <v-select
                style=" max-width: 250px;"
                :items="option_warehouse"
                label="Select Warehouse"
                v-model="warehouse"
                @change="getList"
                item-text="warehouse_name"
                item-value="id"
                class="ma-2"
                hide-details
              >
              </v-select>

              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :search="search"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :footer-props="{ 'items-per-page-options': [30, 50, 100] }"
              :options="{ itemsPerPage: 50 }"
            >
              <template v-slot:[`item.spare_part_master_type`]="{ item }">
                <span v-if="item.spare_part_master_type == 1">Spare Part</span>
                <span v-else-if="item.spare_part_master_type == 2"
                  >Material</span
                >
                <span v-else-if="item.spare_part_master_type == 3"
                  >Not Spare Part & Material</span
                >
              </template>
              <template v-slot:[`item.spare_part_master_category`]="{ item }">
                <span v-if="item.spare_part_master_category == 1"
                  >Fast Moving</span
                >
                <span v-else-if="item.spare_part_master_category == 2"
                  >Slow Moving</span
                >
              </template>
              <template v-slot:[`item.spare_part_master_unit_price`]="{ item }">
                <span style="float: right; "
                  >Rp.{{ formatPrice(item.spare_part_master_unit_price) }}</span
                >
              </template>
              <template
                v-slot:[`item.spare_part_master_alert_price`]="{ item }"
              >
                <span style="float: right; "
                  >Rp.{{
                    formatPrice(item.spare_part_master_alert_price)
                  }}</span
                >
              </template>
              <template v-slot:[`item.dealer_price`]="{ item }">
                <v-btn
                  color="primary"
                  dark
                  x-small
                  @click="viewDealerprice(item)"
                >
                  <v-icon dark x-small>
                    price_check
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <!-- <v-icon
        small
        class="mr-2"
        @click="editData(item.id)"
        v-if="role.update"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.id)"
         v-if="role.delete"
      >
        mdi-delete
      </v-icon> -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      x-small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark x-small>
                        mdi-format-list-bulleted-square
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="role.update" @click="editData(item.id)">
                      <v-list-item-title x-small>Edit</v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item v-if="role.delete" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item> -->
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalPrice" class="coba">
      <template v-slot:header>
        <h3>List Price</h3>
      </template>

      <template v-slot:body>
        <list-price-card :data_id="$refs.modalPrice.data" />
      </template>

      <!-- <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalClosePrice">
            Close
          </md-button>
        </md-card-actions>
      </template> -->
    </modal>
    <modal ref="modalAddRequestSP">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD REQUEST SPARE PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAddRequest()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-req-sp :data_id="$refs.AddRequestSP" />
      </template>
    </modal>
    <modal ref="modalAddTfSP">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
          <h3>ADD TRANSFER SPARE PART</h3>
        </div>
        <md-button
          class="md-icon-button md-dense md-round"
          @click="modalCloseAddTf()"
        >
          <md-icon>close</md-icon>
        </md-button>
      </template>
      <template v-slot:body>
        <add-tf-sp :data_id="$refs.AddTfSP" />
      </template>
    </modal>
  </div>
</template>

<script>
import vuetify from "@/plugins/vuetify";
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { Modal } from "@/components";
import ListPriceCard from "@/pages/Dashboard/Workshop/SparePartMaster/modal/ListPriceCard.vue";
// import AddRequestSP from "@/pages/Dashboard/Workshop/SparePartMaster/modal/AddRequestSPM.vue";
// import AddTfSP from "@/pages/Dashboard/Workshop/SparePartMaster/modal/AddTfSPM.vue";
import { ResizablePage } from "@/components";

export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    ListPriceCard,
    // "add-req-sp": AddRequestSP,
    // "add-tf-sp": AddTfSP,
  },
  vuetify,
  data() {
    return {
      loadTable: true,
      user_warehouse: null,
      warehouse: null,
      option_warehouse: null,
      role: "",
      search: "",
      headers: [
        { text: "Actions", value: "actions", align: "center", sortable: false },
        {
          text: "Type",
          align: "start",
          value: "spare_part_master_type",
          width: "100",
        },
        {
          text: "Part/Material Code",
          value: "spare_part_master_code",
          width: "160",
        },
        {
          text: "Part/Material Name",
          value: "spare_part_master_name",
          width: "200",
        },
        { text: "Unit", value: "spare_part_master_unit" },
        {
          text: "Unit Price",
          value: "spare_part_master_unit_price",
          align: "right",
        },
        { text: "Category", value: "spare_part_master_category", width: "150" },
        {
          text: "Dealer Price",
          value: "dealer_price",
          align: "center",
          sortable: false,
          width: "100",
        },
        {
          text: "Alert Price",
          value: "spare_part_master_alert_price",
          align: "right",
        },
        { text: "Stock", value: "spare_part_master_stock" },
        { text: "Threshold", value: "spare_part_master_threshold" },
        {
          text: "Created At",
          value: "created_at",
          align: "center",
          width: "200",
        },
      ],
      table: [],
      worksheetName: "Spare Part Master",
      fileName: "Spare Part Master.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      field_export: {
        no: "no",
        spare_part_master_code: "spare_part_master_code",
        spare_part_master_name: "spare_part_master_name",
        spare_part_master_unit: "spare_part_master_unit",
        spare_part_master_unit_price: "spare_part_master_unit_price",
        spare_part_master_type: "spare_part_master_type",
        spare_part_master_category: "spare_part_master_category",
        spare_part_master_alert_price: "spare_part_master_alert_price",
        spare_part_master_threshold: "spare_part_master_threshold",
        spare_part_master_stock: "spare_part_master_stock",
        created_at: "created_at",
        updated_at: "updated_at",
      },
    };
  },
  async created() {
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];
    var user = await this.$store.getters["profile/me"];
      // this.user_warehouse = this.user_warehouse.pool;
      if(!user.pool){
        await this.$store.dispatch("workshop_warehouse/list")
        this.option_warehouse = await this.$store.getters["workshop_warehouse/list"];
      }
      else{
        if( user.pool.warehouse.length > 1){
          this.option_warehouse = user.pool.warehouse
        }
        else{
          this.warehouse = user.pool.warehouse[0].id
        }
      }
    this.getList();
    
  },
  methods: {
    // ambil data yang dibutuhkan
    async getList() {

      if(this.warehouse){
        var query = {"filter":{warehouse:this.warehouse}}
        await this.$store.dispatch("workshop_spare_part_master/list",query);
        this.table = await this.$store.getters["workshop_spare_part_master/list"];
      }
      this.loadTable = false;
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
      if (this.$refs.vTable) {
        this.exportAllFitered = this.dataExport(
          this.$refs.vTable.$children[0].filteredItems
        );
      } else {
        this.exportAllFitered = this.dataExport(this.table);
      }
    },

    // format merubah angka ke currency
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    viewDealerprice(item) {
      this.$refs.modalPrice.openModal({
        id: item.id,
        name:
          "(" +
          item.spare_part_master_code +
          ") " +
          item.spare_part_master_name,
      });
    },

    // modalClosePrice() {
    //   this.$refs.modalPrice.closeModal();
    // },
    // fungsi tombol direct ke add page
    addData() {
      // panggil add page
      this.$router.push({ name: "Add Spare Part Master" });
    },

    // fungsi tombol direct ke edit page
    editData(id) {
      // panggil edit page
      this.$router.push({ name: "Edit Spare Part Master", params: { id: id } });
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

    // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_spare_part_master/destroy", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Spare Part Master data delete successfully."
        );
        //await this.getList();
        var indexOptionTable = this.table.findIndex((p) => p.id == id);
        this.table.splice(indexOptionTable, 1);
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data) {
      // return data.map((v,index) => ({...v, no: index+1}))
      var dataReturn = [];
      data.forEach((value_1, index_1) => {
        var type = null;
        var category = null;

        if (value_1.spare_part_master_type == 1) {
          type = "Spare Part";
        } else if (value_1.spare_part_master_type == 2) {
          type = "Material";
        }

        if (value_1.spare_part_master_category == 1) {
          category = "Fast Moving";
        } else if (value_1.spare_part_master_category == 2) {
          category = "Slow Moving";
        }
        var data = {
          no: index_1 + 1,
          spare_part_master_code: value_1.spare_part_master_code,
          spare_part_master_name: value_1.spare_part_master_name,
          spare_part_master_unit: value_1.spare_part_master_unit,
          spare_part_master_unit_price: value_1.spare_part_master_unit_price,
          spare_part_master_type: type,
          spare_part_master_category: category,
          spare_part_master_alert_price: value_1.spare_part_master_alert_price,
          spare_part_master_threshold: value_1.spare_part_master_threshold,
          spare_part_master_stock: value_1.spare_part_master_stock,
          created_at: value_1.created_at,
          updated_at: value_1.updated_at,
        };

        dataReturn.push(data);
      });
      return dataReturn;
    },

    // fungsi untuk display modal add request spare part
    addReqSP() {
      this.$refs.modalAddRequestSP.openModal();
    },

    modalCloseAddRequest() {
      this.$refs.modalAddRequestSP.closeModal();
    },

    addTfSP() {
      this.$refs.modalAddTfSP.openModal();
    },

    modalCloseAddTf() {
      this.$refs.modalAddTfSP.closeModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}

.coba {
  width: 800px !important;
  margin: 50px auto !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}
</style>
